import React from 'react';

const ExcelIcon = ({ size = 20, color = 'currentColor' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flexShrink: 0 }}
    >
        {/* Tray/Container */}
        <path d="M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4" />

        {/* Upward Arrow */}
        <polyline points="8 7 12 3 16 7" />
        <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
);

export default ExcelIcon;
